<template>
  <div class="vp-panel-section">
    <button class="vp-section-toggle" @click="$emit('toggle')">
      <span class="vp-section-toggle__label vp-section-toggle__label--ai">
        <svg width="11" height="11" viewBox="0 0 24 24" fill="none">
          <path
            d="M12 2l1.8 5.2L19 9l-5.2 1.8L12 16l-1.8-5.2L5 9l5.2-1.8z"
            fill="currentColor"
          />
        </svg>
        Eventos IA
      </span>
      <svg
        class="vp-section-toggle__chevron"
        :class="{ 'vp-section-toggle__chevron--up': !collapsed }"
        width="12"
        height="12"
        viewBox="0 0 24 24"
        fill="none"
      >
        <polyline
          points="6,9 12,15 18,9"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          fill="none"
        />
      </svg>
    </button>
    <div v-show="!collapsed" class="vp-section-body">
      <div v-if="loading" class="vp-ai-events__loading">
        Cargando eventos IA…
      </div>
      <ul v-else-if="contextEvents.length > 0" class="vp-ai-events__list">
        <li
          v-for="evt in contextEvents"
          :key="'ctx-' + evt.id"
          class="vp-ai-item"
          :class="{ 'vp-ai-item--active': activeContextEventId === evt.id }"
          @click="$emit('select', evt)"
        >
          <span class="vp-ai-item__badge">IA</span>
          <span class="vp-ai-item__label">
            {{ evt.detectedEventType === "LOAD" ? "Carga" : "Descarga" }}
          </span>
          <span
            v-if="activeContextEventId === evt.id"
            class="vp-ai-item__dot"
          />
          <button
            class="vp-ai-item__delete"
            title="Eliminar evento"
            @click.stop="$emit('delete', evt.id)"
          >
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
              <path
                d="M3 6h18M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2m3 0-1 14a2 2 0 01-2 2H7a2 2 0 01-2-2L4 6h16z"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                fill="none"
              />
            </svg>
          </button>
        </li>
      </ul>
      <div v-else class="vp-ai-events__empty">
        No se han detectado eventos IA en este vídeo.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AIEventsPanel",
  props: {
    collapsed: { type: Boolean, required: true },
    contextEvents: { type: Array, required: true },
    loading: { type: Boolean, default: false },
    activeContextEventId: { type: [Number, String], default: null },
  },
};
</script>

<style>
.vp-ai-events__loading,
.vp-ai-events__empty {
  font-size: 12px;
  color: var(--vp-muted);
  padding: 8px 2px;
  text-align: center;
}
.vp-ai-events__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.vp-ai-item {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 12px;
  border-radius: 7px;
  border: 1.5px solid #e2e8f0;
  background: #fff;
  color: #0f172a;
  font-family: inherit;
  cursor: pointer;
  transition: all 0.15s ease;
}
.vp-ai-item:hover {
  border-color: var(--vp-ai);
  color: var(--vp-ai);
}
.vp-ai-item__badge {
  flex-shrink: 0;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.03em;
  color: #fff;
  background: var(--vp-ai);
  padding: 2px 6px;
  border-radius: 20px;
}
.vp-ai-item__label {
  flex: 1;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vp-ai-item__delete {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: none;
  background: transparent;
  color: var(--vp-muted);
  cursor: pointer;
  flex-shrink: 0;
  opacity: 0;
  transition: all 0.15s ease;
}
.vp-ai-item:hover .vp-ai-item__delete {
  opacity: 1;
}
.vp-ai-item__delete:hover {
  background: rgba(239, 68, 68, 0.12);
  color: #ef4444;
}
.vp-ai-item--active {
  border-color: var(--vp-ai);
  background: var(--vp-ai);
  color: #fff;
  font-weight: 700;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}
.vp-ai-item--active:hover {
  color: #fff;
}
.vp-ai-item--active .vp-ai-item__badge {
  background: #fff;
  color: var(--vp-ai);
}
.vp-ai-item--active .vp-ai-item__delete {
  color: #fff;
}
.vp-ai-item--active .vp-ai-item__delete:hover {
  background: rgba(255, 255, 255, 0.25);
  color: #fff;
}
.vp-ai-item__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #fff;
  flex-shrink: 0;
  animation: aiPulseDot 1.5s ease infinite;
}
@keyframes aiPulseDot {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
}
</style>
